import { render, staticRenderFns } from "./RecoverPasswordForm.vue?vue&type=template&id=2bc1921e&scoped=true"
import script from "./RecoverPasswordForm.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./RecoverPasswordForm.vue?vue&type=style&index=0&id=2bc1921e&prod&lang=scss&scoped=true"
import style1 from "./RecoverPasswordForm.vue?vue&type=style&index=1&id=2bc1921e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc1921e",
  null
  
)

export default component.exports